const SortAsc = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    data-testid="sort-icon-asc"
  >
    <path
      d="M1 5L5 1L9 5"
      stroke="#7C7D7D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SortAsc;
